import * as z from "zod/v4";

const AeoResponseIdentifierSchema_ = z.object({ promptResponseId: z.string() });

export const AeoResponseIdentifierSchema: z.ZodType<AeoResponseIdentifierSchema> =
  AeoResponseIdentifierSchema_;
export interface AeoResponseIdentifierSchema
  extends z.infer<typeof AeoResponseIdentifierSchema_> {}

const AeoResponseMetricSchema_ = z.object({
  promptResponseId: z.string(),
  sourceCount: z.number(),
  brandMentions: z.number(),
});

export const AeoResponseMetricSchema: z.ZodType<AeoResponseMetricSchema> =
  AeoResponseMetricSchema_;
export interface AeoResponseMetricSchema
  extends z.infer<typeof AeoResponseMetricSchema_> {}

export const getAeoResponseMetrics = {
  name: "getAeoResponseMetrics" as const,
  input: z.object({ responses: z.array(AeoResponseIdentifierSchema) }),
  output: z.object({ metrics: z.array(AeoResponseMetricSchema) }),
};
